const Categories = [
    {
        ID: 1,
        name: 'KPI'
    },
    {
        ID: 2,
        name: 'Dailies'
    },
    {
        ID: 3,
        name: 'Technical'
    },
    {
        ID: 4,
        name: 'Marketing'
    },
    {
        ID: 5,
        name: 'Sales'
    },
    {
        ID: 6,
        name: 'Help-desk'
    }
]

export default Categories